import plaintextrequest from '@/utils/plaintextrequest'
import request from '@/utils/request'

// 月卡微信支付
export function newWxpayMonth(data) {
	return request({
		url: '/Monthcard/ykweixin',
		method: 'post',
		data
	})
}

// 月卡支付宝支付
export function newAlipayMonth(data) {
	return request({
		url: '/Monthcard/ykalipay',
		method: 'post',
		data
	})
}

// 周累冲活动
export function week_pay(data) {
	return request({
	  url: "/publicH5/hoardCoins",
	  method: "post",
	  data,
	});
  }
  // 周累冲返利领取
  export function week_pay_get(data) {
	console.log("周累冲返利领取传递的数据----------", data);
	return request({
	  url: "/publicH5/getAccumulateReward",
	  method: "post",
	  data,
	});
  }
  